import React from "react";
import { dateToString } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

// Components
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import TabMenu from "~/common/components/TabMenu";
import { Case, If } from "~/common/components/If";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";

import { useGlobalStore } from "~/store";

const JudgeResultModal = ({
	judgeDetail,
	resultModal,
	setResultModal,
	judgeResultList,
	ModalTab,
	setModalTab,
}) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const { t } = useTranslation();
	return (
		<ModalTemplate
			modalState={resultModal}
			setModalToggle={setResultModal}
			title={t("pages.apply.ApplyManage.Modal.JudgeResultModal.applyResult")}
			width={1000}
			height={748}
			className="result-modal"
		>
			<div className="modal-content">
				{judgeDetail?.apply?.judges.length > 0 ? (
					<div className="scroll-wrap">
						<TabMenu
							tabItem={judgeResultList}
							currentTab={ModalTab}
							setCurrentTab={setModalTab}
						/>
						<If condition={ModalTab}>
							{judgeDetail?.apply?.judges?.map((item) => {
								return (
									<Case condition={item?.user?.id}>
										<div className="judge-form-top">
											<div className="judging-vc-wrap">
												<div className="img-wrap">
													<img
														src={
															item?.user?.img
																? item?.user?.img
																: theme === "dark"
																? DarkDefaultProfileImg
																: LightDefaultProfileImg
														}
														alt={t(
															"pages.apply.ApplyManage.Modal.JudgeResultModal.judgeImg"
														)}
													/>
												</div>
												<dl className="judging-vc">
													<dt>{item.user.name}</dt>
												</dl>
												{item?.score?.totalScore && (
													<div className="judging-vc-score">
														<b>{item.score?.totalScore?.toFixed(2)}</b>
														{t(
															"pages.apply.ApplyManage.Modal.JudgeResultModal.scoreStandard"
														)}
													</div>
												)}
											</div>
											{item.score ? (
												<div className="judging-date">
													{t(
														"pages.apply.ApplyManage.Modal.JudgeResultModal.judgeDate"
													)}
													:{" "}
													{dateToString(
														item?.score?.createdAt,
														"yyyy-MM-dd"
													)}
												</div>
											) : (
												<div className="judging-date waiting">
													{t(
														"pages.apply.ApplyManage.Modal.JudgeResultModal.judgeWaiting"
													)}
												</div>
											)}
										</div>
										{item.score ? (
											<>
												{item?.review?.categories?.map((category) => {
													return (
														<div className="judge-detail-group">
															<div className="judge-detail-item">
																<div className="category-title">
																	{category.title}
																	<span>
																		(
																		{t(
																			"pages.apply.ApplyManage.Modal.JudgeResultModal.weight"
																		)}{" "}
																		: {category.weight}%)
																	</span>
																</div>
																<div className="f__group-row">
																	{category?.items?.map(
																		(item, itemIdx) => {
																			return (
																				<div className="f__group">
																					<div className="f__label">
																						{
																							item.content
																						}
																					</div>
																					<div className="f__control">
																						{
																							item?.score
																						}
																						{t(
																							"pages.apply.ApplyManage.Modal.JudgeResultModal.scoreStandard"
																						)}
																						<b>
																							{t(
																								"pages.apply.ApplyManage.Modal.JudgeResultModal.perfectScore"
																							)}
																						</b>
																					</div>
																				</div>
																			);
																		}
																	)}
																</div>
															</div>
														</div>
													);
												})}

												<div>
													<div className="category-title">
														{t(
															"pages.apply.ApplyManage.Modal.JudgeResultModal.totalEvaluation"
														)}
													</div>
													<div className="f__group">
														<div className="f__control commentary">
															{item?.score?.comment}
														</div>
													</div>
												</div>
											</>
										) : (
											<div className="judge-detail-group no-judging">
												<div className="c__noData">
													<CautionIcon />
													<p className="main">
														{item.user.name}
														{t(
															"pages.apply.ApplyManage.Modal.JudgeResultModal.waitingJudgeMessage"
														)}
													</p>
													<p className="sub">
														{t(
															"pages.apply.ApplyManage.Modal.JudgeResultModal.setJudgeDate"
														)}
														{dateToString(item.createdAt, "yyyy-MM-dd")}
													</p>
												</div>
											</div>
										)}
									</Case>
								);
							})}
						</If>
					</div>
				) : (
					<div className="judge-detail-group no-judging">
						<div className="c__noData">
							<CautionIcon />
							<p className="main">
								{t("pages.apply.ApplyManage.Modal.JudgeResultModal.noJudgeMessage")}
							</p>
							<p className="sub">
								{t(
									"pages.apply.ApplyManage.Modal.JudgeResultModal.setJudgeMessage"
								)}
							</p>
						</div>
					</div>
				)}
			</div>
		</ModalTemplate>
	);
};

export default JudgeResultModal;
